import { useCartCycle } from '@grupoboticario/barril-del-chavo'
import { getConfig } from 'src/helpers'
import { useReseller } from '../useReseller'
import { useUf } from '../useUf'

type UseCycleParams = {
  onCycleCartChanged?: () => void
}

export function useCycle({ onCycleCartChanged }: UseCycleParams = {}) {
  const appConfig = getConfig()
  const reseller = useReseller()
  const state = useUf()

  return useCartCycle(
    {
      state,
      resellerSlug: reseller.data?.catalogSlug,
      businessUnit: appConfig.businessUnit,
    },
    onCycleCartChanged,
  )
}
